/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-10 19:16:31
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-07-13 14:10:11
 */
import 'amfe-flexible';
import Vue from 'vue';
import App from './App';
import accounting from "accounting";
import { router } from './router/index.js';
import store from '@/store';
import "./assets/styles/greenJob.less";
import VueJsBridge from 'vue-webview-js-bridge';
// import Vconsole from 'vconsole';

 (function() {
          var req = new XMLHttpRequest();
           req.open('GET', document.location, false);
           req.send(null);
           var companyCodeHeader=req.getResponseHeader("companyCodeHeader"); // 定制化信息
           var individualHeader=req.getResponseHeader("individual"); // 控制首页相关展示,个体户注册相关
           document.cookie='individualHeader='+individualHeader;
           document.cookie='companyCodeHeader='+companyCodeHeader;
 })();
 // ios使用
Vue.use(VueJsBridge, {
    debug: true,
    nativeHandlerName: 'recordVideo'
})
//货币格式化
Vue.filter('MoneyStringfy', function (value) {
    return accounting.formatMoney(value, { symbol: "", format: "%s%v" })
})
// // 真机调试时使用
// const vConsole = new Vconsole();
// Vue.use(vConsole)
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});


